"use client";

import styles from "@/styles/newsletters/unsubscribe.module.scss";
import { useState, useEffect } from "react";
import myAccountApi from "@/service/modules/myAccountApi";
import { Button, Checkbox } from "react-vant";
import { toast } from '@/components/global/Toast'

interface FormProps {
  email: string;
}

export default function NewslettersUnSubscribe({ email }: FormProps) {
  const [loading, setLoading] = useState(false);

  const [dailyNewsletter, setDailyNewsletter] = useState(false);
  const [normalNewsletter, setNormalNewsletter] = useState(false);
  const [specialsNewsletter, setSpecialsNewsletter] = useState(false);
  const [unsubscribe, setUnsubscribe] = useState(false);
  const [unsubscribeReason2, setUnsubscribeReason2] = useState(false);
  const [unsubscribeReason3, setUnsubscribeReason3] = useState(false);
  const [unsubscribeReason4, setUnsubscribeReason4] = useState(false);
  const [unsubscribeReason5, setUnsubscribeReason5] = useState(false);
  const [unsubscribeReason6, setUnsubscribeReason6] = useState(false);
  const [unsubscribeReason7, setUnsubscribeReason7] = useState(false);

  useEffect(() => {
    getDetail(email)
  }, [])

  const getDetail = async (email: any) => {
    try {
      const res = await myAccountApi.loginOutGetFrontSubscribe({ email })
      const data = res.data

      const initialValues: any = {}

      // 转换成布尔类型
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const element = data[key];
          initialValues[key] = !!element
        }
      }

      console.log(initialValues);
      
      // 将initialValues的值赋给对应的useState状态（简便写法）
      const stateSetters = {
        dailyNewsletter: setDailyNewsletter,
        normalNewsletter: setNormalNewsletter,
        specialsNewsletter: setSpecialsNewsletter,
        unsubscribeReason2: setUnsubscribeReason2,
        unsubscribeReason3: setUnsubscribeReason3,
        unsubscribeReason4: setUnsubscribeReason4,
        unsubscribeReason5: setUnsubscribeReason5,
        unsubscribeReason6: setUnsubscribeReason6,
        unsubscribeReason7: setUnsubscribeReason7
      };
      
      Object.keys(stateSetters).forEach(key => {
        if (initialValues[key] !== undefined) {
          stateSetters[key](initialValues[key]);
        }
      });
    } catch {
      console.log('Fetch Subscribe Failed');
    }
  }

  // 当任意一个newsletter被选中时，自动取消unsubscribe
  useEffect(() => {
    if (dailyNewsletter || normalNewsletter || specialsNewsletter) {
      setUnsubscribe(false);
    }
  }, [dailyNewsletter, normalNewsletter, specialsNewsletter]);

  // 当unsubscribe被选中时，自动取消所有newsletter订阅
  useEffect(() => {
    if (unsubscribe) {
      setDailyNewsletter(false);
      setNormalNewsletter(false);
      setSpecialsNewsletter(false);
    }
  }, [unsubscribe]);

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const dataObj = {
        email: email,
        dailyNewsletter,
        normalNewsletter,
        specialsNewsletter,
        unsubscribe,
        unsubscribeReason2,
        unsubscribeReason3,
        unsubscribeReason4,
        unsubscribeReason5,
        unsubscribeReason6,
        unsubscribeReason7
      };

      const res = await myAccountApi.updateFrontSubscribe(dataObj)
      setLoading(false)
      const { location } = res.data
      if (location) {
        window.location.replace(location)
      }
    } catch (error: any) {
      setLoading(false);
      toast.show(error.message);
    }
  };

  return (
    <div className={styles["unsubscribe-submit"]}>

      <div className={styles["unsubscribe-email"]}>
        <div className={styles["label"]}>
          You are viewing / updating the preferences of email  address:
        </div>

        <div className={styles["value"]}>
          {email}
        </div>
      </div>


      <div className={styles["unsubscribe-title"]}>1. Too Many Emails? Update My Email Preferences</div>

      <Checkbox 
        checked={dailyNewsletter}
        onChange={() => setDailyNewsletter(!dailyNewsletter)}
        shape={'square'}
        iconSize={16}
        style={{ marginTop: '14px' }}
      >
        Daily Emails: Crazy Sales of the Day
      </Checkbox>

      <Checkbox 
        checked={normalNewsletter}
        onChange={() => setNormalNewsletter(!normalNewsletter)}
        shape={'square'}
        iconSize={16}
        style={{ marginTop: '14px', alignItems: 'flex-start' }}
      >
        Weekly Emails: Members Only Promotions, Coupons
      </Checkbox>

      <Checkbox 
        checked={specialsNewsletter}
        onChange={() => setSpecialsNewsletter(!specialsNewsletter)}
        shape={'square'}
        iconSize={16}
        style={{ marginTop: '14px' }}
      >
        Push Notifications
      </Checkbox>

      <Checkbox 
        checked={unsubscribe}
        onChange={() => setUnsubscribe(!unsubscribe)}
        shape={'square'}
        iconSize={16}
        style={{ marginTop: '14px' }}
      >
        Unsubscribe All
      </Checkbox>

      <div className={styles["unsubscribe-title"]}>2. To Help Us Improve Our Service, Please Tell Us the Reasons You Unsubscribed.</div>

      <Checkbox 
        checked={unsubscribeReason2}
        onChange={() => setUnsubscribeReason2(!unsubscribeReason2)}
        shape={'square'}
        iconSize={16}
        style={{ marginTop: '14px', alignItems: 'flex-start' }}
      >
        Like Our Deals But Don&apos;t Want to Receive as Many E-mails?
      </Checkbox>

      <Checkbox 
        checked={unsubscribeReason3}
        onChange={() => setUnsubscribeReason3(!unsubscribeReason3)}
        shape={'square'}
        iconSize={16}
        style={{ marginTop: '14px' }}
      >
        Price is too High
      </Checkbox>

      <Checkbox 
        checked={unsubscribeReason4}
        onChange={() => setUnsubscribeReason4(!unsubscribeReason4)}
        shape={'square'}
        iconSize={16}
        style={{ marginTop: '14px' }}
      >
        Discount is Insufficient
      </Checkbox>

      <Checkbox 
        checked={unsubscribeReason5}
        onChange={() => setUnsubscribeReason5(!unsubscribeReason5)}
        shape={'square'}
        iconSize={16}
        style={{ marginTop: '14px' }}
      >
        Low-quality of Products
      </Checkbox>

      <Checkbox 
        checked={unsubscribeReason6}
        onChange={() => setUnsubscribeReason6(!unsubscribeReason6)}
        shape={'square'}
        iconSize={16}
        style={{ marginTop: '14px' }}
      >
        Not Interested in our Products
      </Checkbox>

      <Checkbox 
        checked={unsubscribeReason7}
        onChange={() => setUnsubscribeReason7(!unsubscribeReason7)}
        shape={'square'}
        iconSize={16}
        style={{ marginTop: '14px' }}
      >
        Poor Email Page Design
      </Checkbox>


      <Button
        round
        type="primary"
        style={{ fontWeight: "700", marginTop: "14px" }}
        loading={loading}
        loadingText="Submit"
        onClick={handleSubmit}
        block
      >
        Unsubscribe
      </Button>
    </div>
  );
}
